import TestOnWay from "./TestOnWay";

export default TestOnWay;
